import { Card, styled } from '../../base';
import { TOP_HEADER_HEIGHT } from '../../common';

export const HEADER_WRAPPER_HEIGHT = 132;
export const FOOTER_WRAPPER_HEIGHT = 60;

export const PageWrapper = styled('div')(({ theme }) => ({
    paddingInline: theme.spacing(5),
    minHeight: `calc(100vh - ${TOP_HEADER_HEIGHT}px)`,
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
}));

export const CardWrapper = styled(Card)(({ theme }) => ({
    padding: theme.spacing(3),
    display: 'flex',
    height: '100%',
    width: '100%',
}));

export const HeaderWrapper = styled('div')(() => ({
    height: `${HEADER_WRAPPER_HEIGHT}px`,
    display: 'flex',
    alignItems: 'center',
}));

export const ContentWrapper = styled('div')(() => ({
    flex: 1,
}));

export const FooterWrapper = styled('div')(() => ({
    height: `${FOOTER_WRAPPER_HEIGHT}px`,
    display: 'flex',
    alignItems: 'center',
    marginTop: 'auto',
}));
